import { apiService } from "redux/services/apiService";

import { CctvDetailResponse, CctvListResponse } from "./types";

const cctvApi = apiService.injectEndpoints({
  endpoints: (build) => ({
    getCctvList: build.query<CctvListResponse, void>({
      query: () => ({
        url: `/cctv`,
      }),
      providesTags: ["cctv"],
    }),
    getCctvById: build.query<CctvDetailResponse, string>({
      query: (id: string) => ({
        url: `/cctv/${id}`,
      }),
      providesTags: (result, error, id) => [{ type: "cctv", id }],
    }),
    getCctvListByLocation: build.query<any, string>({
      query: (cctvLoc: string) => ({
        url: `/cctv?filter[location]=${cctvLoc}`,
      }),
    }),
  }),
  overrideExisting: false,
});

export type { CctvCamera, CctvDetailResponse, CctvListResponse } from "./types";

export const { useGetCctvByIdQuery, useGetCctvListByLocationQuery, useGetCctvListQuery } = cctvApi;

